import { render, staticRenderFns } from "./Form-Dialog.vue?vue&type=template&id=74a56cf6&"
import script from "./Form-Dialog.vue?vue&type=script&lang=js&"
export * from "./Form-Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a56cf6')) {
      api.createRecord('74a56cf6', component.options)
    } else {
      api.reload('74a56cf6', component.options)
    }
    module.hot.accept("./Form-Dialog.vue?vue&type=template&id=74a56cf6&", function () {
      api.rerender('74a56cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form-Dialog.vue"
export default component.exports